import styled from 'styled-components';

export const CourseCodeCellWrapper = styled.div`
  
`;
